import { Card, CardContent, CardHeader, Divider, Box } from '@mui/material';
import React from 'react';

interface MySectionProps {
  title: string;
  description?: string;
  children: React.ReactNode;
  action?: React.ReactNode;
}

export function MySection({ title, description, children, action }: MySectionProps) {
  return (
    <Card sx={{ display: 'flex', flexDirection: 'column' }}>
      <CardHeader
        title={title}
        titleTypographyProps={{
          variant: 'subtitle2',
          sx: {
            fontWeight: 700,
            lineHeight: 1.2,
            fontSize: { xs: '0.9rem', sm: '1rem' }
          }
        }}
        subheader={description}
        subheaderTypographyProps={{
          variant: 'caption',
          sx: {
            display: 'block',
            mt: 0.5,
            lineHeight: 1.3,
            color: 'text.secondary'
          }
        }}
        action={action}
        sx={{
          py: 2,
          px: { xs: 2, sm: 3 },
          display: 'flex',
          // Stack vertically on mobile, horizontally on desktop
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'flex-start', sm: 'center' },
          gap: { xs: 2, sm: 0 },
          '& .MuiCardHeader-content': {
            width: '100%',
          },
          '& .MuiCardHeader-action': {
            alignSelf: { xs: 'flex-start', sm: 'center' },
            m: 0, // Reset default MUI negative margins
            width: { xs: '100%', sm: 'auto' },
          },
        }}
      />
      <Divider />
      <CardContent
        sx={{
          px: { xs: 2, sm: 3 },
          flexGrow: 1,
          // Optional: adjust padding for mobile density
          pt: { xs: 2, sm: 3 }
        }}
      >
        {children}
      </CardContent>
    </Card>
  );
}